import Notifications from 'pages/Notifications'

export default [
    {
        path: '/notifications',
        name: 'notifications',
        component: Notifications,
    }
]
